import React from "react";
import { Tooltip as TooltipRSuite, Whisper } from "rsuite";

import "./index.scss";

interface TooltipProps {
  text: string;
  label: string;
}

const Tooltip = (props: TooltipProps) => {
  const { text, label } = props;

  return (
    <Whisper
      trigger="hover"
      controlId="tooltip"
      placement="auto"
      className="tooltip"
      speaker={<TooltipRSuite arrow={false}>{text}</TooltipRSuite>}
    >
      <span>{label}</span>
    </Whisper>
  );
};

export default Tooltip;
